import { useState } from 'react'

import EnquiryModal from './index'

export const useEnquiryModal = (props) => {
  const [visible, setVisible] = useState(false)

  const render = () =>
    visible ? <EnquiryModal onClose={() => setVisible(false)} {...props} /> : null

  return {
    EnquiryModal: render,
    showEnquiryModal: () => setVisible(true),
  }
}
